module.exports = __webpack_public_path__ + "img/icon_0033.69f1cd40.png";